<template>
  <p class="text-muted text-center">Made by <a href="https://mcklatch.com/hi" rel="noreferrer" target="_blank">McKlatch</a> - see more at <a href="https://dev.mcklatch.com" rel="noreferrer" target="_blank">dev.mcklatch.com</a></p>
</template>

<script>
export default {

}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue